import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, FileText, Receipt, LifeBuoy } from "lucide-react";
import { useClientAuth } from "@/context/ClientAuthContext";
import { QuotesTab } from "@/components/portal/QuotesTab";
import { InvoicesTab } from "@/components/portal/InvoicesTab";
import { TicketsTab } from "@/components/portal/TicketsTab";

const TABS = [
  { id: "devis", label: "Mes devis", icon: FileText, C: QuotesTab },
  { id: "factures", label: "Mes factures", icon: Receipt, C: InvoicesTab },
  { id: "support", label: "Support", icon: LifeBuoy, C: TicketsTab },
];

export default function PortalHome() {
  const { client, logout } = useClientAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("devis");

  useEffect(() => { if (client === false) navigate("/espace-client/connexion"); }, [client, navigate]);
  if (!client) return <div className="min-h-[60vh] grid place-items-center text-slate-400">Chargement…</div>;
  const Active = TABS.find((t) => t.id === tab).C;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="portal-home">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-[#4CB944]">Espace client</div>
          <h1 className="mt-2 text-4xl sm:text-5xl font-bold text-[#0F2A6B] font-head" data-testid="portal-welcome">Bonjour, {client.name}</h1>
          {client.entreprise && <p className="mt-2 text-slate-500">{client.entreprise}</p>}
        </div>
        <button onClick={() => { logout(); navigate("/espace-client/connexion"); }} data-testid="portal-logout" className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold text-slate-600 border border-slate-200 hover:bg-white hover:text-[#0F2A6B]"><LogOut className="w-4 h-4" /> Déconnexion</button>
      </div>
      <nav className="mt-10 flex gap-2 overflow-x-auto pb-1 border-b border-slate-200">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`portal-tab-${t.id}`}
            className={`inline-flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-3 -mb-px text-sm font-semibold border-b-2 whitespace-nowrap transition-colors ${tab === t.id ? "border-[#4CB944] text-[#0F2A6B]" : "border-transparent text-slate-500 hover:text-[#0F2A6B]"}`}>
            <t.icon className="w-4 h-4" />{t.label}
          </button>
        ))}
      </nav>
      <div className="mt-8"><Active /></div>
    </section>
  );
}
